import type { ComponentProps } from "react";

type Props = {
  variant?: "muted" | "active" | "primary" | "fill";
} & ComponentProps<"svg">;

export const DevicesIcon = ({ variant = "primary", ...rest }: Props) => {
  switch (variant) {
    case "muted":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          {...rest}
        >
          <g className="color=muted">
            <g className="Group">
              <path
                fill="#646467"
                d="M14 16.5H3.182c-.1 0-.182.081-.182.182 0 1.004.814 1.818 1.818 1.818h9.284a1.798 1.798 0 0 1-.102-.6v-1.4Zm-8.4-11A1.6 1.6 0 0 0 4 7.1v7.8a1.6 1.6 0 0 0 1.6 1.6H14v-5.2a1.8 1.8 0 0 1 1.8-1.8h3.8c.137 0 .271.015.4.045V7.1a1.6 1.6 0 0 0-1.6-1.6H5.6Z"
                className="Vector"
              />
              <rect
                width="6"
                height="9"
                x="15"
                y="10.5"
                fill="#646467"
                className="active"
                rx="1.6"
              />
            </g>
          </g>
        </svg>
      );
    case "active":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          {...rest}
        >
          <g className="color=active">
            <g className="Group">
              <path
                fill="#646467"
                d="M14 16.5H3.182c-.1 0-.182.081-.182.182 0 1.004.814 1.818 1.818 1.818h9.284a1.798 1.798 0 0 1-.102-.6v-1.4Zm-8.4-11A1.6 1.6 0 0 0 4 7.1v7.8a1.6 1.6 0 0 0 1.6 1.6H14v-5.2a1.8 1.8 0 0 1 1.8-1.8h3.8c.137 0 .271.015.4.045V7.1a1.6 1.6 0 0 0-1.6-1.6H5.6Z"
                className="Vector"
              />
              <rect
                width="6"
                height="9"
                x="15"
                y="10.5"
                fill="#546195"
                className="active"
                rx="1.6"
              />
            </g>
          </g>
        </svg>
      );
    case "primary":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          {...rest}
        >
          <g className="color=primary">
            <g className="Group">
              <path
                fill="#1D2445"
                d="M14 16.5H3.182c-.1 0-.182.081-.182.182 0 1.004.814 1.818 1.818 1.818h9.284a1.798 1.798 0 0 1-.102-.6v-1.4Zm-8.4-11A1.6 1.6 0 0 0 4 7.1v7.8a1.6 1.6 0 0 0 1.6 1.6H14v-5.2a1.8 1.8 0 0 1 1.8-1.8h3.8c.137 0 .271.015.4.045V7.1a1.6 1.6 0 0 0-1.6-1.6H5.6Z"
                className="Vector"
              />
              <rect
                width="6"
                height="9"
                x="15"
                y="10.5"
                fill="#1D2445"
                className="active"
                rx="1.6"
              />
            </g>
          </g>
        </svg>
      );
    case "fill":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          {...rest}
        >
          <g className="color=primary on fill">
            <g className="Group">
              <path
                fill="#fff"
                d="M14 16.5H3.182c-.1 0-.182.081-.182.182 0 1.004.814 1.818 1.818 1.818h9.284a1.798 1.798 0 0 1-.102-.6v-1.4Zm-8.4-11A1.6 1.6 0 0 0 4 7.1v7.8a1.6 1.6 0 0 0 1.6 1.6H14v-5.2a1.8 1.8 0 0 1 1.8-1.8h3.8c.137 0 .271.015.4.045V7.1a1.6 1.6 0 0 0-1.6-1.6H5.6Z"
                className="Vector"
              />
              <rect
                width="6"
                height="9"
                x="15"
                y="10.5"
                fill="#fff"
                className="active"
                rx="1.6"
              />
            </g>
          </g>
        </svg>
      );
  }
};
